module.exports = __webpack_public_path__ + "img/zhAward-c.ae6ebf72.png";